/** Namespace `ai` — PLAT-2026-111 · ADR-032: AI theo app (bật / tắt tính năng, model, ngân sách). */
export const ai = {
  chooseApp: "Chọn ứng dụng",
  featureCount: "{enabled}/{total} tính năng bật",
  appHint: "Thiết lập riêng cho ứng dụng này.",
  settingsSections: "Các phần thiết lập AI",
  sync: "Đồng bộ",
  noLimits: "Ứng dụng này chưa khai báo ngưỡng ngân sách.",
  noSync: "Ứng dụng này chưa có đích đồng bộ cấu hình.",
  featuresHint:
    "Bật hoặc tắt nhanh bằng công tắc. Chọn Chỉnh sửa để đổi mô hình và giới hạn chi phí.",
  syncHint: "Kiểm tra cấu hình ứng dụng đã nhận. Chỉ đẩy lại khi cần đồng bộ.",
  featureOn: "Đang bật",
  featureOff: "Đang tắt",
  edit: "Chỉnh sửa",
  enableFeature: "Bật tính năng này",
  featureId: "Mã tính năng",
  costSummary: "Tối đa {value} USD/lượt",
  costHint: "Để trống để dùng giới hạn mặc định của ứng dụng.",
  saveFeature: "Lưu thay đổi",
  invalidCost: "Trần mỗi lượt phải lớn hơn 0, hoặc để trống để dùng mặc định.",
  budgetTab: "Ngân sách",
  title: "AI",
  titleForApp: "AI — {app}",
  intro: "Chọn ứng dụng để quản lý tính năng AI, mô hình và ngân sách.",
  onlyForApp: "Chỉ hiện {app}.",
  seeAll: "Xem mọi app",
  loadFailed: "Không đọc được thiết lập AI.",
  saveFailed: "Không lưu được.",
  readOnly: "Bạn chỉ có quyền xem. Sửa cần quyền `hq.integrations.write`.",
  openrouter: "Khoá OpenRouter",
  openrouterOn: "Đã gắn « {set} » · đang bật",
  openrouterOff: "Đã gắn « {set} » · đang TẮT — AI của app này không chạy",
  openrouterMissing: "Chưa gắn bộ thông số OpenRouter — AI của app này không chạy",
  openrouterUntested: "bộ chưa chạy thử đạt",
  openrouterManage: "Quản lý khoá",
  features: "Tính năng",
  feature: "Tính năng",
  enabled: "Bật",
  model: "Model",
  modelAppDefault: "Mặc định của app",
  maxCost: "Trần mỗi lượt (USD)",
  maxCostDefault: "mặc định {value}",
  maxCostNone: "theo app",
  overridden: "đã chỉnh",
  defaultState: "mặc định",
  limits: "Ngân sách & ngưỡng",
  limitsHint:
    "Để trống = dùng mặc định. App vẫn tự đếm chi tiêu của mình và tự chặn khi chạm ngưỡng.",
  limitDefault: "mặc định {value}",
  saveLimits: "Lưu ngưỡng",
  saving: "Đang lưu…",
  "unit.usd": "USD",
  "unit.count": "lượt",
  "unit.tokens": "token",
  "unit.bytes": "byte",
  "unit.ms": "ms",
  "period.request": "mỗi lượt",
  "period.day": "mỗi ngày",
  "period.month": "mỗi tháng",
  "period.window": "mỗi cửa sổ",
  "period.total": "tổng",
  invalidNumber: "« {label} » phải là số không âm.",
} as const;
